import { useContractInfo } from './hooks';
import { convertToPresentationProps } from './logics';
import { ContractInfoPresentation } from './presentations';

/**
 * ご契約情報 Container
 *
 * 親コンポーネント（Screen）で Suspense にラップすること
 */
export const ContractInfo: React.FC = () => {
  const {
    state: {
      data,
      creditCardResult,
      stripeSource,
      isFormExpanded,
      errorMessage,
      successMessage,
      isSubmitDisabled,
      paymentFieldResetKey,
    },
    actions: { handleToggleForm, handleSubmitCard },
  } = useContractInfo();

  const {
    companyInfo,
    planInfo,
    contactInfo,
    billingInfo,
    settlementMethodLabel,
    isCardPayment,
    cardLabel,
    cardFetchErrorMessage,
    failedPaymentNoticeMessage,
  } = convertToPresentationProps({
    data,
    creditCardResult,
    stripeSource,
  });

  return (
    <ContractInfoPresentation
      companyInfo={companyInfo}
      planInfo={planInfo}
      contactInfo={contactInfo}
      billingInfo={billingInfo}
      settlementMethodLabel={settlementMethodLabel}
      isCardPayment={isCardPayment}
      cardLabel={cardLabel}
      cardFetchErrorMessage={cardFetchErrorMessage}
      failedPaymentNoticeMessage={failedPaymentNoticeMessage}
      isFormExpanded={isFormExpanded}
      errorMessage={errorMessage}
      successMessage={successMessage}
      isSubmitDisabled={isSubmitDisabled}
      paymentFieldResetKey={paymentFieldResetKey}
      onToggleForm={handleToggleForm}
      onSubmitCard={handleSubmitCard}
    />
  );
};
